export const typeActivity = [
  {
    id: 'downhill',
    label: 'Sjezdové lyžování',
    items: [
      { name: 'shoes', label: 'Boty', categoryId: 'LYZAKY' },
      { name: 'skies', label: 'Lyže', categoryId: 'LYZE' },
      { name: 'sticks', label: 'Hole', categoryId: 'HOLE_SJEZD' },
      { name: 'helmets', label: 'Přilba', categoryId: 'PRILBY' },
      { name: 'sacs', label: 'Vak na lyže', categoryId: 'VAK' },
      { name: 'bags', label: 'Taška na boty', categoryId: 'TASKA' },
      { name: 'glasses', label: 'Lyžařské brýle', categoryId: 'BRYLE' },
      { name: 'backbone_guard', label: 'Chránič páteře', categoryId: 'PATERAK' },
    ],
    attributes: ['Hmotnost', 'Výška', 'Věk', 'Lyžařské zkušenosti'],
  },
  {
    id: 'snowboard',
    label: 'Snowboard',
    items: [
      { name: 'shoes', label: 'Boty', categoryId: 'BOTY_SNB' },
      { name: 'snbs', label: 'Snowboardy', categoryId: 'SNB' },
      { name: 'helmets', label: 'Přilba', categoryId: 'PRILBY' },
      { name: 'sacs', label: 'Vak na lyže', categoryId: 'VAK' },
      { name: 'glasses', label: 'Lyžařské brýle', categoryId: 'BRYLE' },
      { name: 'backbone_guard', label: 'Chránič páteře', categoryId: 'PATERAK' },
    ],
    attributes: ['Výška', 'Noha vpředu'],
  },
  {
    id: 'crossCountry',
    label: 'Běžecké lyžování',
    items: [
      { name: 'shoes', label: 'Boty', categoryId: 'BOTY_BEH' },
      { name: 'skies', label: 'Lyže', categoryId: 'BEZKY' },
      { name: 'sticks', label: 'Hole', categoryId: 'HOLE_BEH' },
      { name: 'sacs', label: 'Vak na lyže', categoryId: 'VAK' },
      { name: 'bags', label: 'Taška na boty', categoryId: 'TASKA' },
    ],
    attributes: ['Hmotnost', 'Výška'],
  },
];

export const discountConfig = { until: '11-30', free: ['PRILBY'] };

/*export const rent = [
  {
    category: 'LYZAKY',
    items: [
      { days: 1, price: 100, price235: 80 },
      { days: 2, price: 140, price235: 110 },
      { days: 3, price: 180, price235: 140 },
      { days: 4, price: 220, price235: 170 },
      { days: 5, price: 260, price235: 200 },
      { days: 6, price: 300, price235: 230 },
      { days: 7, price: 350, price235: 250 },
      { days: 8, price: 350, price235: 250 },
      { days: 9, price: 350, price235: 250 },
      { days: 10, price: 350, price235: 250 },
      { days: 11, price: 350, price235: 250 },
      { days: 12, price: 570, price235: 440 },
      { days: 13, price: 660, price235: 530 },
      { days: 14, price: 750, price235: 620 },
      { days: 15, price: 800, price235: 700 },
      { days: '>15', discount: true, price: 680, price235: 595 },
      { days: '>15', discount: false, price: 800, price235: 700 }
    ]
  },
  {
    category: 'BOTY_SNB',
    items: [
      { days: 1, price: 100 },
      { days: 2, price: 150 },
      { days: 3, price: 200 },
      { days: 4, price: 250 },
      { days: 5, price: 300 },
      { days: 6, price: 350 },
      { days: 7, price: 400 },
      { days: 8, price: 400 },
      { days: 9, price: 400 },
      { days: 10, price: 400 },
      { days: 11, price: 400 },
      { days: 12, price: 620 },
      { days: 13, price: 700 },
      { days: 14, price: 780 },
      { days: 15, price: 800 },
      { days: '>15', discount: true, price: 680 },
      { days: '>15', discount: false, price: 800 }
    ]
  },
  {
    category: 'BOTY_BEH',
    items: [
      { days: 1, price: 100 },
      { days: 2, price: 130 },
      { days: 3, price: 160 },
      { days: 4, price: 190 },
      { days: 5, price: 220 },
      { days: 6, price: 250 },
      { days: 7, price: 280 },
      { days: 8, price: 280 },
      { days: 9, price: 280 },
      { days: 10, price: 280 },
      { days: 11, price: 280 },
      { days: 12, price: 500 },
      { days: 13, price: 600 },
      { days: 14, price: 700 },
      { days: 15, price: 800 },
      { days: '>15', discount: true, price: 680 },
      { days: '>15', discount: false, price: 800 }
    ]
  },
  {
    category: 'LYZE',
    items: [
      { days: 1, price: 150, priceTOP: 300, price130: 140 },
      { days: 2, price: 220, priceTOP: 450, price130: 180 },
      { days: 3, price: 290, priceTOP: 600, price130: 220 },
      { days: 4, price: 360, priceTOP: 750, price130: 260 },
      { days: 5, price: 430, priceTOP: 900, price130: 300 },
      { days: 6, price: 500, priceTOP: 1050, price130: 340 },
      { days: 7, price: 550, priceTOP: 1200, price130: 350 },
      { days: 8, price: 550, priceTOP: 1200, price130: 350 },
      { days: 9, price: 550, priceTOP: 1200, price130: 350 },
      { days: 10, price: 550, priceTOP: 1200, price130: 350 },
      { days: 11, price: 550, priceTOP: 1200, price130: 350 },
      { days: 12, price: 860, priceTOP: 1870, price130: 600 },
      { days: 13, price: 970, priceTOP: 2110, price130: 710 },
      { days: 14, price: 1080, priceTOP: 2350, price130: 820 },
      { days: 15, price: 1100, priceTOP: 2400, price130: 900 },
      {
        days: '>15',
        discount: true,
        price: 935,
        priceTOP: 2040,
        price130: 765
      },
      {
        days: '>15',
        discount: false,
        price: 1100,
        priceTOP: 2400,
        price130: 900
      }
    ]
  },
  {
    category: 'SNB',
    items: [
      { days: 1, price: 200 },
      { days: 2, price: 260 },
      { days: 3, price: 320 },
      { days: 4, price: 380 },
      { days: 5, price: 440 },
      { days: 6, price: 500 },
      { days: 7, price: 550 },
      { days: 8, price: 550 },
      { days: 9, price: 550 },
      { days: 10, price: 550 },
      { days: 11, price: 550 },
      { days: 12, price: 830 },
      { days: 13, price: 920 },
      { days: 14, price: 1010 },
      { days: 15, price: 1000 },
      { days: '>15', discount: true, price: 850 },
      { days: '>15', discount: false, price: 1000 }
    ]
  },
  {
    category: 'BEZKY',
    items: [
      { days: 1, price: 200 },
      { days: 2, price: 220 },
      { days: 3, price: 240 },
      { days: 4, price: 260 },
      { days: 5, price: 280 },
      { days: 6, price: 300 },
      { days: 7, price: 320 },
      { days: 8, price: 320 },
      { days: 9, price: 320 },
      { days: 10, price: 320 },
      { days: 11, price: 320 },
      { days: 12, price: 590 },
      { days: 13, price: 730 },
      { days: 14, price: 870 },
      { days: 15, price: 1000 },
      { days: '>15', discount: true, price: 850 },
      { days: '>15', discount: false, price: 1000 }
    ]
  },
  {
    category: 'HOLE_SJEZD',
    items: [
      { days: 1, price: 30 },
      { days: 2, price: 35 },
      { days: 3, price: 40 },
      { days: 4, price: 50 },
      { days: 5, price: 60 },
      { days: 6, price: 70 },
      { days: 7, price: 80 },
      { days: 8, price: 80 },
      { days: 9, price: 80 },
      { days: 10, price: 80 },
      { days: 11, price: 80 },
      { days: 12, price: 120 },
      { days: 13, price: 130 },
      { days: 14, price: 140 },
      { days: 15, price: 140 },
      { days: '>15', discount: true, price: 119 },
      { days: '>15', discount: false, price: 140 }
    ]
  },
  {
    category: 'HOLE_BEH',
    items: [
      { days: 1, price: 50 },
      { days: 2, price: 60 },
      { days: 3, price: 70 },
      { days: 4, price: 80 },
      { days: 5, price: 90 },
      { days: 6, price: 100 },
      { days: 7, price: 100 },
      { days: 8, price: 100 },
      { days: 9, price: 100 },
      { days: 10, price: 100 },
      { days: 11, price: 100 },
      { days: 12, price: 160 },
      { days: 13, price: 180 },
      { days: 14, price: 200 },
      { days: 15, price: 200 },
      { days: '>15', discount: true, price: 170 },
      { days: '>15', discount: false, price: 200 }
    ]
  },
  {
    category: 'PRILBY',
    items: [
      { days: 1, price: 50 },
      { days: 2, price: 70 },
      { days: 3, price: 90 },
      { days: 4, price: 110 },
      { days: 5, price: 130 },
      { days: 6, price: 150 },
      { days: 7, price: 150 },
      { days: 8, price: 150 },
      { days: 9, price: 150 },
      { days: 10, price: 150 },
      { days: 11, price: 150 },
      { days: 12, price: 260 },
      { days: 13, price: 310 },
      { days: 14, price: 360 },
      { days: 15, price: 400 },
      { days: '>15', discount: true, price: 340 },
      { days: '>15', discount: false, price: 400 }
    ]
  },
  {
    category: 'VAK',
    items: [
      { days: 1, price: 50 },
      { days: 2, price: 60 },
      { days: 3, price: 70 },
      { days: 4, price: 80 },
      { days: 5, price: 90 },
      { days: 6, price: 100 },
      { days: 7, price: 100 },
      { days: 8, price: 100 },
      { days: 9, price: 100 },
      { days: 10, price: 100 },
      { days: 11, price: 100 },
      { days: 12, price: 160 },
      { days: 13, price: 180 },
      { days: 14, price: 200 },
      { days: 15, price: 200 },
      { days: '>15', discount: true, price: 170 },
      { days: '>15', discount: false, price: 200 }
    ]
  },
  {
    category: 'TASKA',
    items: [
      { days: 1, price: 50 },
      { days: 2, price: 60 },
      { days: 3, price: 70 },
      { days: 4, price: 80 },
      { days: 5, price: 90 },
      { days: 6, price: 100 },
      { days: 7, price: 100 },
      { days: 8, price: 100 },
      { days: 9, price: 100 },
      { days: 10, price: 100 },
      { days: 11, price: 100 },
      { days: 12, price: 160 },
      { days: 13, price: 180 },
      { days: 14, price: 200 },
      { days: 15, price: 200 },
      { days: '>15', discount: true, price: 170 },
      { days: '>15', discount: false, price: 200 }
    ]
  },
  {
    category: 'BRYLE',
    items: [
      { days: 1, price: 50 },
      { days: 2, price: 70 },
      { days: 3, price: 90 },
      { days: 4, price: 110 },
      { days: 5, price: 130 },
      { days: 6, price: 150 },
      { days: 7, price: 150 },
      { days: 8, price: 150 },
      { days: 9, price: 150 },
      { days: 10, price: 150 },
      { days: 11, price: 150 },
      { days: 12, price: 260 },
      { days: 13, price: 310 },
      { days: 14, price: 360 },
      { days: 15, price: 400 },
      { days: '>15', discount: true, price: 340 },
      { days: '>15', discount: false, price: 400 }
    ]
  }
];*/

//Nastavení pro QR kod
export const ageArr = [
  { id: 0, val: '1 - 10' },
  { id: 1, val: '11 - 50' },
  { id: 2, val: '51+' },
];

export const weightArr = [
  { id: 0, val: '1 - 14' }, // opravit podle stroje
  { id: 1, val: '15 - 17' }, // opravit podle stroje
  { id: 2, val: '18 - 21' },
  { id: 3, val: '22 - 25' },
  { id: 4, val: '26 - 30' },
  { id: 5, val: '31 - 35' },
  { id: 6, val: '36 - 41' },
  { id: 7, val: '42 - 48' },
  { id: 8, val: '49 - 57' },
  { id: 9, val: '58 - 66' },
  { id: 10, val: '67 - 78' },
  { id: 11, val: '79 - 94' },
  { id: 12, val: '94+' },
];

export const heightArr = [
  { id: 0, min: 0, max: 148 },
  { id: 1, min: 149, max: 157 },
  { id: 2, min: 158, max: 166 },
  { id: 3, min: 167, max: 178 },
  { id: 4, min: 179, max: 194 },
  { id: 5, min: 195, max: 240 },
];

export const shoeLengthArr = [
  { id: 0, min: 0, max: 230 },
  { id: 1, min: 231, max: 250 },
  { id: 2, min: 251, max: 270 },
  { id: 3, min: 271, max: 290 },
  { id: 4, min: 291, max: 310 },
  { id: 5, min: 311, max: 330 },
  { id: 6, min: 331, max: 350 },
  { id: 7, min: 351, max: 999 },
];

export const skillArr = [
  { id: -1, val: '1 - začátečník' },
  { id: 0, val: '2 - pokročilý' },
  { id: 1, val: '3 - rekreační' },
  { id: 2, val: '4 - sportovní' },
  { id: 3, val: '5 - expert' },
];

export const shoeBrandArr = [
  { id: 0, val: 'Alpina' },
  { id: 1, val: 'Atomic' },
  { id: 2, val: 'Booster' },
  { id: 3, val: 'Botas' },
  { id: 4, val: 'Caber' },
  { id: 5, val: 'Dachstein' },
  { id: 6, val: 'Dalbello' },
  { id: 7, val: 'Dolomite' },
  { id: 8, val: 'Dynafit' },
  { id: 9, val: 'Elan' },
  { id: 10, val: 'Fischer' },
  { id: 11, val: 'Head' },
  { id: 12, val: 'K2' },
  { id: 13, val: 'Kastinger' },
  { id: 14, val: 'Lange' },
  { id: 15, val: 'Lowa' },
  { id: 16, val: 'Munari' },
  { id: 17, val: 'Nordica' },
  { id: 18, val: 'Raichle' },
  { id: 19, val: 'Rossignol' },
  { id: 20, val: 'Roxa' },
  { id: 21, val: 'Salomon' },
  { id: 22, val: 'Scarpa' },
  { id: 23, val: 'Sportisimo' },
  { id: 24, val: 'Tecnica' },
  { id: 25, val: 'Tecno' },
  { id: 26, val: 'Roces' },
  { id: 27, val: 'Wedze' },
  { id: 98, val: 'Jiné' },
];

export const skiBrandArr = [
  { id: 0, val: 'Armada' },
  { id: 1, val: 'Artist' },
  { id: 2, val: 'Atomic' },
  { id: 3, val: 'Blizzard' },
  { id: 4, val: 'Bogner' },
  { id: 5, val: 'Cooper' },
  { id: 6, val: 'Dynamic' },
  { id: 7, val: 'Dynastar' },
  { id: 8, val: 'Elan' },
  { id: 9, val: 'Fat-Ypus' },
  { id: 10, val: 'Fischer' },
  { id: 11, val: 'Head' },
  { id: 12, val: 'Jade' },
  { id: 13, val: 'K2' },
  { id: 14, val: 'Kastle' },
  { id: 15, val: 'Kneissl' },
  { id: 16, val: 'Line' },
  { id: 17, val: 'Lusti' },
  { id: 18, val: 'Majesty' },
  { id: 19, val: 'Nordica' },
  { id: 20, val: 'Pale' },
  { id: 21, val: 'Rossignol' },
  { id: 22, val: 'Salomon' },
  { id: 23, val: 'Scott' },
  { id: 24, val: 'Select' },
  { id: 25, val: 'Sporten' },
  { id: 26, val: 'Stöckl' },
  { id: 27, val: 'Tecno' },
  { id: 28, val: 'Vist' },
  { id: 29, val: 'Volant' },
  { id: 30, val: 'Völkl' },
  { id: 31, val: 'Wedze' },
  { id: 98, val: 'Jiné' },
];

export const skiBindingBrandArr = [
  { id: 0, val: 'Atomic' },
  { id: 1, val: 'Blizzard' },
  { id: 2, val: 'Dynastar' },
  { id: 3, val: 'Elan' },
  { id: 4, val: 'ETK' },
  { id: 5, val: 'Fischer' },
  { id: 6, val: 'Head' },
  { id: 7, val: 'Look' },
  { id: 8, val: 'Marker' },
  { id: 9, val: 'Nordica' },
  { id: 10, val: 'Rossignol' },
  { id: 11, val: 'Stockl' },
  { id: 12, val: 'Salomon' },
  { id: 13, val: 'Tecno' },
  { id: 14, val: 'Tyrolia' },
  { id: 15, val: 'Vist' },
  { id: 16, val: 'Wedze' },
  { id: 98, val: 'Jiné' },
];

export const skiBindingTypeArr = [
  { id: 0, val: 26 },
  { id: 1, val: 45 },
  { id: 2, val: 70 },
  { id: 3, val: 75 },
  { id: 4, val: 80 },
  { id: 5, val: 90 },
  { id: 6, val: 95 },
  { id: 7, val: 100 },
  { id: 8, val: 110 },
  { id: 9, val: 120 },
  { id: 10, val: 130 },
  { id: 11, val: 140 },
  { id: 12, val: 150 },
  { id: 13, val: 160 },
  { id: 14, val: 170 },
  { id: 15, val: 180 },
];



// WEBPACK FOOTER //
// ./src/modules/reservations/config.js